import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { videoService } from '../services/api';
import './VideoGallery.css';

const VideoGallery = () => {
  const [videos, setVideos] = useState([]);
  const [filteredVideos, setFilteredVideos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const data = await videoService.getAllVideos();
        setVideos(data);
        setFilteredVideos(data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load videos. Please try again later.');
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  useEffect(() => {
    // Filter videos based on search term
    if (videos.length > 0) {
      const results = videos.filter(video =>
        video.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredVideos(results);
    }
  }, [searchTerm, videos]);

  if (loading) return <div className="page"><div className="loading">Loading videos...</div></div>;
  if (error) return <div className="page"><div className="error">{error}</div></div>;

  return (
    <div className="page video-gallery">
      <h1>Family Videos</h1>
      
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search videos..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      
      {filteredVideos.length > 0 ? (
        <div className="video-grid">
          {filteredVideos.map(video => (
            <Link to={`/videos/${video.id}`} key={video.id} className="video-card">
              <div className="video-info">
                <h3>{video.title}</h3>
                <p>{new Date(video.date).toLocaleDateString()}</p>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="no-results">No videos found</div>
      )}
    </div>
  );
};

export default VideoGallery; 